import axios from "axios";
import { useAuth } from "../navigation/AuthProvider";
import { BACKEND_URL } from "../constants";



export const create_new_customer = async ({user, company, newCustomerParams}) => {

    if(!user || !company) return alert("Kunde inte skapa kund")


    const { data } = await axios.post(`${BACKEND_URL}/create-new-customer`, {
        userId: user._id,
        companyId: company._id,
        newCustomerParams
    }, { withCredentials: true })

    return data

}


export const edit_customer = async ({user, company, customer, newCustomerParams}) => {

    if(!user || !company) return alert("Kunde inte redigera kund")

    
    const { data } = await axios.post(`${BACKEND_URL}/edit-customer`, {
        userId: user._id,
        companyId: company._id,
        customerId: customer._id,
        newCustomerParams
    })

    return data
}



export const delete_customer = async ({user, company, customer}) => {

    if(!user || !company) return alert("Kunde inte redigera kund")

    
    const { data } = await axios.post(`${BACKEND_URL}/delete-customer`, {
        userId: user._id,
        companyId: company._id,
        customerId: customer._id,
    })

    return data
}
